







import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import DataContainer from "@vuetifyx/common/DataContainer";
import userManager from "@/services/userManager";

export default Vue.extend({
  data() {
    return {
      self: this,
      country: null,
      item: null,
      tableOptions: null,
    };
  },
  computed: {
    breadcrumbItems() {
      if (!this.country || !this.item) {
        return [];
      }
      return [
        {
          text: `${this.item.name} - ${this.item.sku}`,
          disabled: true,
        },
        {
          text: "QL Sản phẩm",
          to: `/app/countries/${this.country._id}/product_groups/${this.item._id}/products`,
          "active-class": "router-link-active",
        },
      ];
    },
  },
  methods: {
    makeTableOptions(country, item) {
      const options = {
        attrs: {
          "item-key": "_id",
          "sort-by": "createdTime",
          "sort-desc": true,
          "show-select": true,
        },
        content: {
          name: "Quản lý sản phẩm",
          urlEnabled: true,
          search: {},
          displayFields: {
            sku: {
              text: "SKU",
              sortable: true,
              width: "200px",
            },
            name: {
              text: "Tên",
              sortable: true,
            },
            priceInherited: {
              text: "Lấy giá từ NSP",
              options: {
                boolean: true,
              },
            },
            count: userManager.checkRole(["kt", "qlk"]) && {
              text: "SL thực trong kho",
              options: {
                subProp: "totalCountStatus.count",
                sortBy: "totalCountStatus.count",
              },
            },
            expectedCount: userManager.checkRole(["kt", "qlk"]) && {
              text: "SL trong kho (Dự kiến)",
              options: {
                subProp: "totalCountStatus.expectedCount",
                sortBy: "totalCountStatus.expectedCount",
              },
            },
            expectedImportCount: userManager.checkRole(["kt", "qlk"]) && {
              text: "SL dự kiến về",
              options: {
                subProp: "totalCountStatus.expectedImportCount",
                sortBy: "totalCountStatus.expectedImportCount",
              },
            },
            mktCount: {
              text: "SL Marketing",
              options: {
                transform(_, item) {
                  return (
                    item.overriddenMktCount ||
                    (item.totalCountStatus &&
                      (item.totalCountStatus.expectedCount || 0) + (item.totalCountStatus.expectedImportCount || 0)) ||
                    0
                  );
                },
              },
            },
            returnCount: userManager.checkRole(["kt", "vdl", "vd"]) && {
              text: "SL return",
              options: {
                subProp: "totalCountStatus.returnCount",
                sortBy: "totalCountStatus.returnCount",
              },
            },
            localPrice: userManager.checkRole(["kt", "mkt", "tp", "rd", "rdl", "vdl", "vd"]) && {
              text: "Giá bán nội địa",
              sortable: true,
              options: {
                filter: "currency",
                transform(value) {
                  return `${value} ${country.currency}`;
                },
              },
            },
            localShippingCost: userManager.checkRole(["kt", "vdl", "vd"]) && {
              text: "Chi phí ship nội địa",
              sortable: true,
              options: {
                filter: "currency",
                transform(value) {
                  return `${value} ${country.currency}`;
                },
              },
            },
            expectedRevenue: userManager.checkRole(["kt", "mkt", "tp", "rd", "rdl", "vdl", "vd"]) && {
              text: "Doanh thu MKT",
              options: {
                preTransform(_, item) {
                  let value = (item.localPrice - item.localShippingCost) * country.exchangeRate;
                  if (isNaN(value)) {
                    value = 0;
                  }
                  return value;
                },
                filter: "currency",
                transform(value) {
                  return `${value} VNĐ`;
                },
              },
            },
            description: {
              text: "Mô tả",
            },
            createdTime: {
              text: "Ngày tạo",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            action: {},
          },
          topActionButtons: {
            export: userManager.checkRole(["kt"]) && {
              attrs: {
                color: "default",
                dark: false,
              },
              content: {
                text: "Xuất Excel",
                icon: "mdi-microsoft-excel",
              },
              on: {
                xClick({ self }) {
                  const dataTable = self.context();
                  let findAllOptions = dataTable.getFindAllOptions();
                  if (dataTable.model.value.length) {
                    findAllOptions = {
                      payload: JSON.stringify({
                        filters: [
                          {
                            key: "_id",
                            operator: "in",
                            value: dataTable.model.value.map((item) => item._id),
                          },
                        ],
                        limit: -1,
                      }),
                    };
                  }
                  coreApiClient.download("products", `@/export`, findAllOptions);
                },
              },
            },
            generateProducts: userManager.checkRole(["kt", "qlk"]) && {
              attrs: {},
              content: {
                text: "Tạo sản phẩm tự động",
                icon: "fas fa-cubes",
                iconAttrs: {
                  class: "ml-1",
                },
              },
              target: {
                dialog: {
                  handlers: {
                    initialize() {
                      this.options.content.buttons.save.states.enabled = new DataContainer(false);
                    },
                  },
                  content: {
                    toolbar: {
                      title: "Tạo sản phẩm tự động",
                    },
                    content: {
                      type: "XForm",
                      makeAttrs(attrs, dialog) {
                        const skuTemplateItems = [];
                        for (const { key } of item.properties) {
                          skuTemplateItems.push(`{${key}}`);
                        }
                        const skuTemplate = skuTemplateItems.length
                          ? `${item.sku}-${skuTemplateItems.join("-")}`
                          : item.sku;

                        attrs.xModel = dialog.options.content.buttons.save.states.enabled;
                        attrs.xContext = dialog;
                        attrs.xData = new DataContainer({
                          priceInherited: true,
                          skuTemplate,
                        });
                        return attrs;
                      },
                      attrs: {
                        xOptions: {
                          content: {
                            sections: {
                              default: {
                                fields: {
                                  skuTemplate: {
                                    attrs: {
                                      label: "Mẫu SKU",
                                    },
                                  },
                                  priceInherited: {
                                    type: "boolean",
                                    attrs: {
                                      label: "Lấy giá từ nhóm sản phẩm",
                                    },
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                    buttons: {
                      save: {
                        content: {
                          text: "Cập nhật",
                        },
                        states: {},
                        on: {
                          async xClick({ self }) {
                            const dialog = self.context();
                            const btn = dialog.context();
                            const dataTable = btn.context();
                            const form = dialog.contentContainer.value;
                            const data = form.getData();
                            self.loading.value = true;
                            const result = await dataTable.execute(
                              async () => {
                                return await coreApiClient.call(
                                  "productGroups",
                                  "createProducts",
                                  {
                                    id: item._id,
                                  },
                                  data
                                );
                              },
                              undefined,
                              {
                                disableLoading: true,
                                willRefresh: true,
                              }
                            );
                            self.loading.value = false;
                            if (result) {
                              dialog.hide();
                            }
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
            insert: userManager.checkRole(["kt", "qlk"]) && {},
          },
          template: {
            itemActionButtons: {
              edit: userManager.checkRole(["kt", "qlk"]) && {
                target: {
                  dialog: {
                    ext: {
                      subTitleMaker: "sku",
                    },
                  },
                },
              },
              delete: userManager.checkRole(["kt"]) && {},
              updatePrice: userManager.checkRole(["kt"]) && {
                attrs: {},
                content: {
                  icon: "mdi-currency-usd",
                },
                target: {
                  tooltip: {
                    content: {
                      text: "Cập nhật giá",
                    },
                  },
                  dialog: {
                    handlers: {
                      initialize() {
                        this.options.content.buttons.save.states.enabled = new DataContainer(false);
                      },
                    },
                    content: {
                      toolbar: {
                        title: "Cập nhật giá",
                        subTitle(dialog) {
                          const btn = dialog.context();
                          const { item } = btn.context();
                          return item.sku || item.name;
                        },
                      },
                      content: {
                        type: "XForm",
                        makeAttrs(attrs, dialog) {
                          const { item } = dialog.context().context();
                          attrs.xModel = dialog.options.content.buttons.save.states.enabled;
                          attrs.xContext = dialog;
                          attrs.xData = new DataContainer({
                            newLocalPrice: item.localPrice,
                            newLocalShippingCost: item.localShippingCost,
                          });
                          return attrs;
                        },
                        attrs: {
                          xOptions: {
                            content: {
                              sections: {
                                default: {
                                  fields: {
                                    newLocalPrice: {
                                      type: "number",
                                      attrs: {
                                        label: "Giá bán nội địa",
                                        required: true,
                                        "prepend-icon": "mdi-currency-usd",
                                        suffix: country.currency,
                                        autofocus: true,
                                      },
                                    },
                                    newLocalShippingCost: {
                                      type: "number",
                                      attrs: {
                                        label: "Chi phí ship nội địa",
                                        required: true,
                                        "prepend-icon": "mdi-currency-usd",
                                        suffix: country.currency,
                                      },
                                    },
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                      buttons: {
                        save: {
                          content: {
                            text: "Cập nhật",
                          },
                          states: {},
                          on: {
                            async xClick({ self }) {
                              const dialog = self.context();
                              const btn = dialog.context();
                              const { item, dataTable } = btn.context();
                              const form = dialog.contentContainer.value;
                              const data = form.getData();
                              self.loading.value = true;
                              const result = await dataTable.execute(
                                async () => {
                                  return await coreApiClient.call(
                                    "products",
                                    "update",
                                    {
                                      id: item._id,
                                    },
                                    {
                                      data: {
                                        localPrice: data.newLocalPrice,
                                        localShippingCost: data.newLocalShippingCost,
                                      },
                                    }
                                  );
                                },
                                undefined,
                                {
                                  disableLoading: true,
                                  willRefresh: true,
                                }
                              );
                              self.loading.value = false;
                              if (result) {
                                dialog.hide();
                              }
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          findAllOptionsFilter(options) {
            options.filters.push({
              key: "countryId",
              operator: "equal_to",
              value: this.context().$route.params.countryId,
            });
            options.filters.push({
              key: "productGroupId",
              operator: "equal_to",
              value: this.context().$route.params.productGroupId,
            });
            return options;
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const { items, count } = await coreApiClient.call("products", "findAll", options);
              return [items, count];
            },
            async insert(item, dataTable) {
              item.countryId = dataTable.context().$route.params.countryId;
              item.productGroupId = dataTable.context().$route.params.productGroupId;
              return await coreApiClient.call("products", "create", undefined, item);
            },
            async update(item) {
              return await coreApiClient.call(
                "products",
                "update",
                {
                  id: item._id,
                },
                {
                  data: item,
                }
              );
            },
            async delete(item) {
              return await coreApiClient.call("products", "delete", {
                id: item._id,
              });
            },
          },
          default: {
            defaultInputs: {
              sku: {
                attrs: {
                  label: "SKU",
                  required: true,
                },
              },
              name: {
                attrs: {
                  label: "Tên",
                },
              },
              description: {
                type: "textLarge",
                attrs: {
                  label: "Mô tả",
                },
              },
              priceInherited: {
                type: "boolean",
                attrs: {
                  label: "Lấy giá từ NSP",
                },
              },
              overriddenMktCount: {
                type: "number",
                attrs: {
                  label: "Số lượng MKT (ghi đè)",
                },
              },
              localPrice: {
                type: "number",
                attrs: {
                  label: "Giá bán nội địa",
                  "prepend-icon": "mdi-currency-usd",
                  suffix: country.currency,
                },
              },
              localShippingCost: userManager.checkRole(["kt", "vdl", "vd"]) && {
                type: "number",
                attrs: {
                  label: "Chi phí ship nội địa",
                  "prepend-icon": "mdi-currency-usd",
                  suffix: country.currency,
                },
              },
            },
            insertForm: userManager.checkRole(["kt", "qlk"]) && {
              content: {
                fieldNames: [
                  "sku",
                  "name",
                  "description",
                  "overriddenMktCount",
                  "priceInherited",
                  "localPrice",
                  "localShippingCost",
                ],
              },
            },
            editForm: userManager.checkRole(["kt", "qlk"]) && {
              content: {
                fieldNames: [
                  "sku",
                  "name",
                  "description",
                  "overriddenMktCount",
                  "priceInherited",
                  "localPrice",
                  "localShippingCost",
                ],
              },
            },
            delete: userManager.checkRole(["kt"]) && {
              confirmDisplayField: "sku",
            },
          },
        },
      };
      if (item.properties) {
        const extraDisplayFields = {};
        const extraInputFields = [];
        for (const property of item.properties) {
          const key = `property_${property.key}`;
          extraDisplayFields[key] = {
            text: property.label,
            options: {
              subProp: `propertyValues.${property.key}`,
              transform(value) {
                return `<span class="font-weight-bold red--text">${value}</span>`;
              },
            },
          };
          const defaultInput: any = {
            attrs: {
              label: property.label || property.key,
              required: true,
            },
            ext: {
              formProperty: `propertyValues.${property.key}`,
            },
          };
          if (property.type === "select") {
            defaultInput.type = "select";
            defaultInput.attrs.items = property.selections;
          }
          options.ext.default.defaultInputs[key] = defaultInput;
          extraInputFields.push(key);
        }
        options.content.displayFields = Object.assign(extraDisplayFields, options.content.displayFields);
        if (options.ext.default.insertForm) {
          options.ext.default.insertForm.content.fieldNames.unshift(...extraInputFields);
        }
        if (options.ext.default.editForm) {
          options.ext.default.editForm.content.fieldNames.unshift(...extraInputFields);
        }
      }
      return options;
    },
  },
  async created() {
    this.country = await coreApiClient.call("countries", "findById", {
      id: this.$route.params.countryId,
    });
    this.item = await coreApiClient.call("productGroups", "findById", {
      id: this.$route.params.productGroupId,
    });
    this.tableOptions = this.makeTableOptions(this.country, this.item);
  },
});
